$(document).ready(function() {
	
	// sticky header transition
	$(window).on('scroll', function () {
		if ($(this).scrollTop() > 0) {
			$('.site-header').addClass('site-header-scrolling');
		} else {
			$('.site-header').removeClass('site-header-scrolling');
		}
	}).trigger('scroll');
	
});